var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgDownload = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M11.25,14.1893398 L11.25,2 C11.25,1.58578644 11.5857864,1.25 12,1.25 C12.4142136,1.25 12.75,1.58578644 12.75,2 L12.75,14.1893398 L15.4696699,11.4696699 C15.7625631,11.1767767 16.2374369,11.1767767 16.5303301,11.4696699 C16.8232233,11.7625631 16.8232233,12.2374369 16.5303301,12.5303301 L12.5303301,16.5303301 C12.2374369,16.8232233 11.7625631,16.8232233 11.4696699,16.5303301 L7.46966991,12.5303301 C7.1767767,12.2374369 7.1767767,11.7625631 7.46966991,11.4696699 C7.76256313,11.1767767 8.23743687,11.1767767 8.53033009,11.4696699 L11.25,14.1893398 Z M2.25,17 C2.25,16.5857864 2.58578644,16.25 3,16.25 C3.41421356,16.25 3.75,16.5857864 3.75,17 L3.75,20 C3.75,20.6903559 4.30964406,21.25 5,21.25 L19,21.25 C19.6903559,21.25 20.25,20.6903559 20.25,20 L20.25,17 C20.25,16.5857864 20.5857864,16.25 21,16.25 C21.4142136,16.25 21.75,16.5857864 21.75,17 L21.75,20 C21.75,21.5187831 20.5187831,22.75 19,22.75 L5,22.75 C3.48121694,22.75 2.25,21.5187831 2.25,20 L2.25,17 Z"
  }));
};
export default SvgDownload;